import React from 'react';
import ReactDOM from 'react-dom';
import TemplateBuilder from './TemplateBuilder';
import autoBind from 'react-autobind';
import FileSaver from "file-saver";
import CodeMirror from 'codemirror/src/codemirror'
import Templates from './Templates';
import CodeMirrorProperties from './CodeMirrorProperties'
import '../Styling/codemirror.css'
import Resizable from 're-resizable';
import Dialog from './Dialog';
import clsStopwatch from './ClsStopwatch';
import URLGenerator from './URLGenerator';
import '../Styling/clientPageStyling.css'
import '../Styling/modalStyling.css';

CodeMirror.defineMode("properties", CodeMirrorProperties);
CodeMirror.defineMIME("text/x-properties", "properties");
CodeMirror.defineMIME("text/x-ini", "properties");

var clusterDefaultSide = {
	'com': 'la',
	'eu' : 'ie'
};
var maxRedirectErrorText =
	'Your browser has reached its maximum number of redirects for this request.  Please contact your support representative with this information: \n\n';
var dir = document.URL.substring(0, document.URL.lastIndexOf('/')) + "/";
var xClientName = "TdeTemplateBuilder/1.0";


class TDEClient extends React.Component{
	constructor(props){
		super(props);
		this.state = {
			token: "",
			username: "",
			password: "",
			isDeleteTemplateDialogOpen: false,
			isLoginErrorOpen: false,
			isMissingNameDialogOpen: false,
			isCheckLengthDialogOpen: false,
			isCheckForbiddenDialogOpen: false,
			windowHeight: 322,
			windowMinHeight: 322
		};
		this.x = new clsStopwatch();
		this.$time = null;
		this.clocktimer = null;
		this.isDirty = false;
		this.tbEditor = null;
		this.tbStatus = false;
		this.currentEditorState = null;
		autoBind(this);


	}



	getQuerystring(key, defaultValue) {
		if (defaultValue == null) defaultValue = "";
		key = key.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
		var regex = new RegExp("[\\?&]" + key + "=([^&#]*)");
		var qs = regex.exec(window.location.href);
		if (qs == null)
			return defaultValue;
		else
			return qs[1];
	}

	checkForAuthToken() {
		document.getElementById("authToken").value = this.getQuerystring("auth");
	}

	btnList_onclick() {
		var token = document.getElementById("authToken").value;
		this.tokenAcquired(token);

		this.buildList(-1);
	}

	btnLoginUserPass_onclick() {
		var xhr = new XMLHttpRequest();
		xhr.onreadystatechange = function() {
			if (xhr.readyState !== 4) {
				return;
			}
			this.stopTimer();
			if (xhr.status !== 200) {
				alert("error status code " + xhr.status + "\n" + xhr.responseText);
				return;
			}
			var response = JSON.parse(xhr.responseText);
			document.getElementById("authToken").value = response.token;
			this.tokenAcquired(response.token);
			this.buildList(-1);
		}.bind(this);
		var user = document.getElementById("username").value;
		var pass = document.getElementById("password").value;
		var url = URLGenerator.GetURLNoAuth('rest/login');
		xhr.open("POST", url, true); 
		xhr.setRequestHeader("Content-Type", "application/json");
		xhr.setRequestHeader("X-Client-Name", xClientName);
		this.startTimer();
		var details = { username: user, password: pass };
		xhr.send(JSON.stringify(details));
	}

	buildList(showId) {
		var xhr = new XMLHttpRequest();
		xhr.onreadystatechange = function () {
			if (xhr.readyState !== 4) {
				return;
			}
			this.stopTimer();
			if (xhr.status !== 200) {
				alert("error status code " + xhr.status + "\n" + xhr.responseText);
				return;
			}
			var list = document.getElementById("cbTemplates");
			for (let i = list.length - 1; i >= 0; i--) {
				list.options[i] = null;
			}
			var response = JSON.parse(xhr.responseText);
			for (let i = 0; i < response.templates.length; i++) {
				var template = response.templates[i];
				var name = template["name"];
				let id = template["templateId"];
				list.options[list.length] = new Option(name, id);
			}
			if (showId < 0) {
				if (list.length > 0) {
					let id = document.getElementById('cbTemplates').value;
					this.viewTemplate(id);
				}
			} else {
				this.viewTemplate(showId);
				document.getElementById('cbTemplates').value = showId;
			}
		}.bind(this);
		var url = URLGenerator.GetURL('templates',"?");
		TDEClient.setLastWebRequest(url);
		xhr.open("GET", url, true);
		this.startTimer();
		xhr.setRequestHeader("X-Client-Name", xClientName);
		xhr.send("");
	}

	changeSelection() {
		// Switching templates is just a view/navigation action — it must not be blocked by
		// validation of the currently displayed (possibly invalid, unsaved) template content.
		var id = document.getElementById('cbTemplates').value;
		this.viewTemplate(id);
	}

	viewTemplate(id) {
		var xhr = new XMLHttpRequest();
		xhr.onreadystatechange = function () {
			if (xhr.readyState !== 4) {
				return;
			}
			this.stopTimer();
			if (xhr.status !== 200) {
				alert("error status code " + xhr.status + "\n" + xhr.responseText);
				return;
			}
			this.tbEditor.setValue(xhr.responseText);
			this.clearDirtyFlag();
		}.bind(this);
		var url = URLGenerator.GetURL("templates/"+id, "?");
		TDEClient.setLastWebRequest(url);
		xhr.open("GET", url, true);
		xhr.setRequestHeader("X-Client-Name", xClientName);
		this.startTimer();
		xhr.send("");
	}

	btnUpdate_onclick() {
		try {
			var selectionList = document.getElementById('cbTemplates');
			var id = selectionList.value;
			var name = selectionList.children[selectionList.selectedIndex].text;
			this.UpdateOrCreate(id, name, false);
		}
		catch (e) {
			console.error(e);
		}
	}

	validateTemplateName(name) {
		const MAX_LENGTH = 150;
		const FORBIDDEN_CHARS_REGEX = /[\\/<>:\"|?*!@#$%^&+\(\);=`{}\[\],~']/;
		if (!name || name === "") {
			this.setState({ isMissingNameDialogOpen: true });
			return false;
		}
		if (name.length > MAX_LENGTH) {
			this.setState({ isCheckLengthDialogOpen: true });
			return false;
		}
		if (FORBIDDEN_CHARS_REGEX.test(name)) {
			this.setState({ isCheckForbiddenDialogOpen: true });
			return false;
		}
		return true; 
	}

	UpdateOrCreate(id, name, thenRun) {
		if (this.isDirty) {
			var data = this.tbEditor.getValue();
        	var match = data.match(/TemplateName\s*=\s*(.*)/i);
        	if (!match || !match[1] || match[1].trim() === "") {
        		this.setState({ isMissingNameDialogOpen: true });
        		return;
        	}
        	var extractedName = match[1].trim();
        	if (!this.validateTemplateName(extractedName)) {
        		return;
        	}
        	var templateName = match[0];
			var quotedName = this.quoteRegExpSpecialCharacters(name);
			var regexTemplateMatch = new RegExp("(\\s)*=(\\s)*" + quotedName + "(\\s)*(#.*)?$");
			if (templateName.match(regexTemplateMatch)) {
				var xhr = new XMLHttpRequest();
				xhr.onreadystatechange = function () {
					if (xhr.readyState !== 4) {
						return;
					}
					this.stopTimer();
					if (xhr.status !== 200) {
						alert("error status code " + xhr.status + "\n" + xhr.responseText);
						return;
					}
					this.clearDirtyFlag();
					if (thenRun) {
						this.StartRun(id);
					}
				}.bind(this);
				var url = URLGenerator.GetURL("templates/" + id, "?");
				TDEClient.setLastWebRequest(url);
				xhr.open("POST", url, true);
				xhr.setRequestHeader("X-Client-Name", xClientName);
				this.startTimer();
				xhr.send(data);
			} else {
				this.Create(data, thenRun);
			}
		} else if (thenRun) {
			this.StartRun(id);
		}
	}

	quoteRegExpSpecialCharacters(text){
		return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
	};

	btnCreate_onclick() {
		var data = this.tbEditor.getValue();
		var match = data.match(/TemplateName\s*=\s*(.*)/i);		
		if (match && match[1]) {
			var templateName = match[1].trim(); 
			if (!this.validateTemplateName(templateName)) {
				return; 
			}
		}
		this.Create(data, false);
	}

	Create(data, thenRun) {
		var xhr = new XMLHttpRequest();
		xhr.onreadystatechange = function () {
			if (xhr.readyState !== 4) {
				return;
			}
			this.stopTimer();
			if (xhr.status !== 200) {
				alert("error status code " + xhr.status + "\n" + xhr.responseText);
				return;
			}
			var response = JSON.parse(xhr.responseText);
			var id = response["templateId"];

			this.buildList(id);
			if (thenRun) {
				this.StartRun(id);
			}
		}.bind(this);
		var url = URLGenerator.GetURL("templates/", "?");
		xhr.open("POST", url, true);
		xhr.setRequestHeader("X-Client-Name", xClientName);
		this.startTimer();
		xhr.send(data);
	}

	btnDelete_onclick() {
		if (document.cookie.indexOf("dontAsk") === -1) {
			this.ConfirmDelete();
		} else {
			this.deleteTemplate();
		}
	}

	ConfirmDelete(){
		this.setState ({
			isDeleteTemplateDialogOpen: true
		});
	}

	deleteTemplate() {
		var xhr = new XMLHttpRequest();
		var id = document.getElementById('cbTemplates').value;
		var url = URLGenerator.GetURL("templates/" + id, "?");
		xhr.onreadystatechange = function () {
			this.stopTimer();
			if (xhr.status === 200) {
				this.buildList(-1);
			}
		}.bind(this);
		xhr.open("DELETE", url, true);
		xhr.setRequestHeader("X-Client-Name", xClientName);
		this.startTimer();
		xhr.send("");
	}

	closeDialogAndManageCookie() {
		this.handleClose();
		this.setDontAskAgainCookie();
	}

	setDontAskAgainCookie() {
		var ignoreDeleteCheckbox = document.getElementById('ignoreDeleteCheckbox');
		var ignoreDeleteChecked = ignoreDeleteCheckbox.checked;
		ignoreDeleteCheckbox.checked = false;
		if (!ignoreDeleteChecked) {
			return;
		}
		var d = new Date();
		d.setTime(d.getTime() + (86400000)); //set the time to 24 hours later
		var expires = "expires="+d.toUTCString();
		document.cookie = "dontAskForDelete=true; " + expires;
	}

	btnRun_onclick() {
		var selectionList = document.getElementById('cbTemplates');
		var id = selectionList.value;
    	var name = selectionList.children[selectionList.selectedIndex].text;
		this.UpdateOrCreate(id, name, true);
	}

	btnRunOnly_onclick() {
		var data = this.tbEditor.getValue(); 
		var match = data.match(/TemplateName\s*=\s*(.*)/i);		
		var templateName = (match && match[1]) ? match[1].trim() : "";
		if (templateName && !this.validateTemplateName(templateName)) {
			return;
		}
		this.runWithInputData(null, this.runOnlyCallback);
	}

	runWithInputData(id, callback) {
		if (document.getElementById("checkBoxRawInput").checked) {
			var rawInput = document.getElementById("textBoxRawInput").value;
			callback(id, rawInput);
			return;
		}

		var file = document.getElementById("inputFile").files[0];

		if (file) {
			const allowedExtensions = [".csv", ".txt", ".xlsx"];
			const dangerousExtensions = [".exe", ".dll", ".bat", ".cmd", ".com", ".msi", ".js", ".vbs", ".ps1", ".sh", ".php", ".asp", ".aspx", ".jsp", ".html", ".htm", ".svg", ".xml", ".xsl"];
			const fileName = file.name;
			const extension = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
			const baseName = fileName.substring(0, fileName.lastIndexOf('.'));

			// Check intermediate extensions for dangerous patterns (e.g., "file.exe.csv")
			const parts = fileName.split('.');
			const hasUnsafeIntermediateExtension = parts.slice(1, -1).some(function(part) {
				return dangerousExtensions.includes('.' + part.toLowerCase());
			});

			if (!allowedExtensions.includes(extension) ||
				hasUnsafeIntermediateExtension ||
				!baseName ||
				fileName.startsWith(".")) {
				alert("Invalid file upload.");
				return;
			}
			var reader = new FileReader();
			reader.onload = function (theFile) {
				var contents = theFile.target.result;
				callback(id, contents);
			};
			reader.readAsText(file);
			return;
		}
		callback(id, "");
	}

	runOnlyCallback(id, inputData) {
		var query = document.getElementById("queryString").value;
		var template = this.tbEditor.getValue();
		var postData = Templates.getPostBody(inputData, template);
		this.runTemplate(null, query, postData);
	}

	StartRun(id) {
		this.runWithInputData(id, this.runCallback);
	}

	runCallback(id, postData) {
		var query = document.getElementById("queryString").value;
		this.runTemplate(id, query, postData);
	}

	runTemplate(id, query, post) {
		TDEClient.setExecutionStatus("");
		var startTime = new Date().toISOString();
		var xhr = new XMLHttpRequest();
		var url = id ? URLGenerator.GetURL("execute?template=" + id, "&") : URLGenerator.GetURL("execute", "?");
		var mode = this.getPollingMode(query);
		if (query.length > 0) {
			url += "&" + query;
		}
		if (!mode) {
			mode = "redirect202";
			url += url.indexOf("?") == -1 ? "?" : "&";
			url += "PollingMode=redirect202";
		}
		xhr.onreadystatechange = function () {
			if (xhr.readyState !== 4) {
				return;
			}
			if (xhr.status === 0 && mode === "redirect303") {
				document.getElementById("tbResults").value = maxRedirectErrorText + "Request URL: " + dir + url + '\nStart time: ' + startTime;
				return;
			}
			if (xhr.status !== 200 && xhr.status !== 202) {
				this.requestError(xhr);
				return;
			}
			var result = xhr.responseText;
			if (xhr.status === 202) {
				TDEClient.setResults(xhr);
				setTimeout(function () {
					this.pollResults(JSON.parse(result).ResultUrl, mode);
				}.bind(this), mode === "redirect202" ? 0 : 10000);
			} else {
				this.requestSuccess(xhr);
			}
			TDEClient.setLastWebRequest(url);
		}.bind(this);
		xhr.open("POST", url, true);
		xhr.setRequestHeader("X-Client-Name", xClientName);
		this.startTimer();
		TDEClient.enableUi(false);
		xhr.send(post);
	}

	pollResults(url, mode) {
		var xhr = new XMLHttpRequest();
		xhr.onreadystatechange = function () {
			if (xhr.readyState !== 4) {
				return;
			}
			if (xhr.status !== 200 && xhr.status !== 202) {
				this.requestError(xhr);
			}
			if (xhr.status === 202) {
				TDEClient.setResults(xhr);
				setTimeout(function () {
					this.pollResults(url, mode);
				}.bind(this), mode === "redirect202" ? 0 : 10000);
			} else {
				this.requestSuccess(xhr);
			}
		}.bind(this);
		xhr.open("GET", url, true);
		xhr.setRequestHeader("X-Client-Name", xClientName);
		xhr.send("");
	}

	requestError(xhr) {
		this.stopTimer();
		TDEClient.setResults(xhr);
		TDEClient.setExecutionStatus(xhr.status);
		TDEClient.enableUi(true);
	}

	requestSuccess(xhr) {
		TDEClient.setExecutionStatus(xhr.status);
		TDEClient.setOrDownloadResults(xhr);
		TDEClient.enableUi(true);
		this.stopTimer();
	}

	getPollingMode(query) {
		var pairs = query.toLowerCase().split('&');
		var result = {};
		pairs.forEach(function(pair) {
			pair = pair.split('=');
			result[pair[0]] = pair[1];
		});

		return result["pollingmode"] || TDEClient.getForceAsyncMode(result["forceasyncmode"]) || undefined;
	}

	static getForceAsyncMode(value) {
		if (value === "on" || value === "yes" || value === "true") {
			return "async";
		}
		return undefined;
	}


	setDirtyFlag() {
		this.isDirty = true;
	}

	clearDirtyFlag() {
		this.isDirty = false;
	}

	static setResults(xhr) {
		var text = TDEClient.getResponseText(xhr.responseText, TDEClient.getResponseType(xhr));
		document.getElementById("tbResults").value = text;
	}

	static setOrDownloadResults(xhr) {
		var type = TDEClient.getResponseType(xhr);
		var text = TDEClient.getResponseText(xhr.responseText, type);
		if (document.getElementById("checkBoxDownload").checked) {
			var filename = "TDE_Results." + (type === "text" ? "csv" : type);
			TDEClient.saveTextAsFile(text, filename);
			document.getElementById("tbResults").value = "Downloaded file " + filename;
		} else {
			document.getElementById("tbResults").value = text;
		}
	}

	static getResponseType(xhr) {
		var type = "text";
		var contentType = xhr.getResponseHeader("Content-Type");
		if (TDEClient.stringStartsWith(contentType, "application/json")) {
			type = "json";
		} else if (TDEClient.stringStartsWith(contentType, "text/xml")) {
			type = "xml";
		}
		return type;
	}

	static stringStartsWith(string, prefix) {
		return string.slice(0, prefix.length) === prefix;
	}

	static getResponseText(response, type) {
		var text;
		if (type === "json") {
			try {
				var json = JSON.parse(response);
				text = JSON.stringify(json, undefined, 2);
			} catch (error) {
				text = 'Client could not parse response! There was likely a server error.\n' + error + '\n\nActual Response from Server:\n' + response;
			}
		} else {
			text = response;
		}
		return text;
	}

	static saveTextAsFile(textToWrite, filename) {
		var blob = new Blob([textToWrite], { type: "text/plain;charset=utf-8" });
		FileSaver.saveAs(blob, filename);
		return filename;
	}

	static btnClear_onclick() {
		document.getElementById("inputFile").value = "";
	}

	static btnClearResponse_onclick() {
		document.getElementById("tbResults").value = "";
	}

	static checkBoxRawInput_onchange(element) {
		document.getElementById('textBoxRawInput').hidden = !element.checked;
		document.getElementById('inputFile').hidden = element.checked;
		document.getElementById('btnClear').hidden = element.checked;
	}

	static setLastWebRequest(url) {
		if (url.search(/https?:\/\//i) === 0) {
			document.getElementById("lastAddress").value = url;
		} else {
			document.getElementById("lastAddress").value = dir + url;
		}
	}

	static pad(num, size) {
		var s = "0000" + num;
		return s.substr(s.length - size);
	}

	static formatTime(time) {
		var h, m, s, ms, newTime;

		h = Math.floor(time / (60 * 60 * 1000));
		time = time % (60 * 60 * 1000);
		m = Math.floor(time / (60 * 1000));
		time = time % (60 * 1000);
		s = Math.floor(time / 1000);
		ms = time % 1000;

		newTime = TDEClient.pad(h, 2) + ':' + TDEClient.pad(m, 2) + ':' + TDEClient.pad(s, 2) + '.' + TDEClient.pad(ms, 3);
		return newTime;
	}

	show() {
		this.$time = document.getElementById('time');
		this.update();
	}

	update() {
		this.$time.innerHTML = TDEClient.formatTime(this.x.time());
	}

	startTimer() {
		this.x.reset();
		this.clocktimer = setInterval(this.update, 1);
		this.x.start();
	}

	stopTimer() {
		this.x.stop();
		clearInterval(this.clocktimer);
	}

	static setExecutionStatus(status) {
		document.getElementById("textBoxStatus").value = status;
	}

	static enableUi(enabledState) {
		var div = document.getElementsByName("runDivButton");
		for (let i = 0; i < div.length; i++){
			div[i].disabled = !enabledState;
		}
		div = document.getElementsByName("templateManagementDropdowns");
		for (let i = 0; i < div.length; i++){
			div[i].disabled = !enabledState;
		}
		document.getElementById("btnAuthLogin").disabled = !enabledState;
		document.getElementById("btnLogin").disabled = !enabledState;
	}

	dispPopUp() {		
		if(this.state.token !== '' && !this.x.timer){
			document.getElementById('popupModal').style.display = "block";
			this.currentEditorState = this.tbEditor.getValue();
			this.tbEditor.setValue("");
			this.tbStatus = true;
		}
		else{
			this.setState ({
				isLoginErrorOpen: true
			});
		}	
	}

	removePopUp() {
		let nameInput = document.getElementById('nameEntry');
		let rawTemplateName = nameInput.value;
		if (!this.validateTemplateName(rawTemplateName)) {
			if (nameInput.value !== "") {
				nameInput.value = ""; 
			}
			let templateTextArea = document.getElementById('template-textarea');
        	if (templateTextArea) {
           	  let currentText = templateTextArea.value;
              let updatedText = currentText.replace(/(TemplateName\s*=\s*)(.*)/i, "$1");
             templateTextArea.value = updatedText;
        	}
        	return;
		}						
		let template = document.getElementById('template-textarea').value; 
		document.getElementById("tbView").value = template;
		this.tbEditor.setValue(template); 
		document.getElementById('popupModal').style.display = "none";
		this.tbStatus = false;
	}


	cancelTemplateBuilder() {
		this.tbEditor.setValue(this.currentEditorState);
		this.tbStatus = false;
		document.getElementById('popupModal').style.display = "none";
	}

	tokenAcquired(token){
		this.setState({
			token: token
		});
		ReactDOM.render(<TemplateBuilder token = {token}/>, document.getElementById("template-builder-content"));
	}

	authHandler(event){
		if (event.key === "Enter") {
			this.btnList_onclick();
		}
	}

	loginHandler(event){
		if (event.key === "Enter") {
			this.btnLoginUserPass_onclick();
		}
	}

	resizeHandler(e, data) {
		let y = this.state.windowHeight;
		y = y + e.movementY;
		if (y > this.state.windowMinHeight) {
			document.getElementById('tbResults').style.height = y;
			this.setState({
				windowHeight: y
			});
			this.tbEditor.setSize(null, y);
		}
	}

	splitResize(size) {
		this.tbEditor.setSize(size-10, null);
		console.log(size);
	}

	handleClose(){
		this.setState ({
			isDeleteTemplateDialogOpen: false
		});
	}



	componentDidMount(){
		this.tbEditor = CodeMirror.fromTextArea(document.getElementById('tbView'));
		this.tbEditor.on('change', this.setDirtyFlag);
		this.checkForAuthToken(); 
		this.show();
		document.body.onkeyup = function (event) {
			if(this.tbStatus){
				if (event.key === "Escape"){
					this.cancelTemplateBuilder();
				}
			}
		}.bind(this);


	}


	render(){
		return(
			<div id="fullPage">
				<div id="delete-confirm">
					<div className='modal-content' style={{height: "180px", width: "320px", marginTop: "15%"}}>
						<Dialog
							isOpen={this.state.isDeleteTemplateDialogOpen}
							title="Delete Template?"
							height={160}
							width={314}
							overflow = "auto"
							buttons={[
								{
									text: "Yes",
									onClick: () => {
										this.closeDialogAndManageCookie();
										this.deleteTemplate();
									}
								},
								{
									text: "No",
									onClick: () => this.closeDialogAndManageCookie()
								}
							]}>
							<p>
								<span className="ui-icon ui-icon-alert" style={{ float: "left", margin: "0 7px 20px 0" }}></span>
								The template will be deleted and cannot be recovered. Are you sure?
							</p>
							<div id="dont-ask">
								<input id="ignoreDeleteCheckbox" type='checkbox' />
								Do not warn me again for 24 hours.
							</div>
						</Dialog>
					</div>
				</div>
				<div id='login-dialog'>
					<div id='login-dialog-content' className='modal-content' style={{height: "250px", width: "285px", padding: '0'}}>
						<Dialog
							isOpen={this.state.isLoginErrorOpen}
							title="" 
							height={250}
							width={285}
							overflow=""
							buttons={[]}>
	
							<div className='clearfix' style={{ backgroundColor: "rgba(0,0,0,.1" }}>
								<h4 style={{ fontWeight: 'bold', paddingLeft: '3px' }}>Login Error</h4>
							</div>

							<div>
								<p>
									TemplateBuilder can only be accessed once login has been successfully completed.
								</p>
							</div>

							<div>
								<input
									type='button'
									value='Close'
									style={{ marginLeft: '39%' }}
									onClick={() => this.setState({isLoginErrorOpen: false})}
								/>
							</div>
						</Dialog>
					</div>
				</div>
					<div id='missing-name-dialog'>
						<div id='missing-name-dialog-content' className='modal-content' style={{height: "200px", width: "300px", padding: '0'}}>
						<Dialog
							isOpen={this.state.isMissingNameDialogOpen}
							title=""
						 height={200}
							width={300}
							overflow=""
							buttons={[]}>
							<div className='clearfix' style={{ backgroundColor: "rgba(0,0,0,0.1)" }}>
								<h4 style={{ fontWeight: 'bold', paddingLeft: '3px', margin: 0 }}>
									Incomplete Template
								</h4>
							</div>
							<div>
								<p style={{ paddingTop: '10px', paddingLeft: '3px' }}>
									Please enter a Template Name.
								</p>
							</div>
							<div style={{ marginTop: '5px' }}>
								<input
									type='button'
									value='Close'
									style={{ marginLeft: '39%' }}
									onClick={() => this.setState({isMissingNameDialogOpen: false})}
								/>
							</div>
						</Dialog>
					</div>
				</div>
				<div id='checkLength-name-dialog'>
					<div id='checkLength-name-dialog-content' className='modal-content' style={{height: "200px", width: "330px", padding: '0'}}>
						<Dialog
							isOpen={this.state.isCheckLengthDialogOpen}
							title=""
							height={200}
							width={330}
							overflow=""
							onClose={() => this.setState({ isCheckLengthDialogOpen: false })}
							buttons={[]}
						>
							<div className='clearfix' style={{backgroundColor: "rgba(0,0,0,.1"}}><h4 style={{fontWeight: 'bold', paddingLeft:'3px'}}>Template Name Too Long</h4></div>
							<div><p style={{paddingTop: '10px', paddingLeft:'3px'}}>The Template Name is too long. Please ensure your entry is under 150 characters.</p></div>
							<div style={{textAlign: 'center', marginTop: '8px'}}><input type='button' value='Close' onClick={() => this.setState({ isCheckLengthDialogOpen: false })}/></div>
						</Dialog>
					</div>
				</div>
				<div id='checkForbidden-name-dialog'>
					<div id='checkForbidden-name-content' className='modal-content' style={{height: "250px", width: "420px", padding: '0'}}>
						<Dialog
							isOpen={this.state.isCheckForbiddenDialogOpen}
							title=""
							height={250}
							width={420}
							overflow="auto"
							onClose={() => this.setState({ isCheckForbiddenDialogOpen: false })}
							buttons={[]}
						>
							<div className='clearfix' style={{backgroundColor: "rgba(0,0,0,.1"}}><h4 style={{fontWeight: 'bold', paddingLeft:'3px'}}>Invalid Characters</h4></div>
							<div><p style={{paddingTop: '10px', paddingLeft:'10px', paddingRight:'10px'}}>
								Template Names cannot contain special characters such as: <br />
                    			<b>\ / &lt; &gt; : " | ? * ! @ # $ % ^ &amp; + ( ) ; = ` { } [ ] , ~ '</b> <br />
                    			Please use only letters, numbers, underscores, spaces, dots, and hyphens.
							</p></div>
							<div style={{textAlign: 'center', marginTop: '8px'}}><input type='button' value='Close' onClick={() => this.setState({ isCheckForbiddenDialogOpen: false })}/></div>
        				</Dialog>
    				</div>
				</div>
				<div id="rightcolumn" style={{float: "right", padding: "5px"}}>
					<img src="./img/verizon-connect.png" alt="Verizon Connect Logo" style={{height: "80px", width: '152px'}}/>
				</div>
				<h1 style={{fontSize: "29px !important"}}>TDE Template Builder</h1>
				<div className="clientapp" style={{margin: '10px'}}>
					<div id="popupModal" className="modal">
						<div className="modal-content" style={{overflow:"hidden"}}>
							<div id="template-builder-content">
							</div>
							<input id="createTemplate" type="button" value="Done" onClick={() => this.removePopUp()} />
							<input id="cancelTemplate" type='button' value="Cancel" onClick={() => this.cancelTemplateBuilder()}/>
						</div>

					</div>
					<div>
						<label form='lastAddress' style={{float: "left", fontWeight: 'normal'}}>Last Web Request Address:</label>
						<span style={{display: "block", overflow: "hidden", paddingRight: "20px", paddingLeft: "10px"}}>
                        <input id="lastAddress" type="text" readOnly="readonly" style={{width:"100%"}} />
                    </span>
					</div>
					<h2 style={{margin: "0", paddingTop: "10px", clear: "both"}}>Authentication</h2>
					<div style={{paddingTop: "5px"}}>
						<div style={{width: "800px", float:"left", height:"inherit"}}>
							<div style={{paddingTop: "5px"}}>
								Authorization Token:
								<input id="authToken" type="text" onKeyUp={(event) => this.authHandler(event)} style={{marginLeft: '1%'}}/>
								<input type="button" value="Login" id="btnAuthLogin" onClick={() => this.btnList_onclick()} style={{marginLeft: '4px'}}/>
								<br /><b>Or</b><br />
								Username:
								<input id="username" type="text" style={{marginLeft: '1%', marginRight: '1%'}}/>
								Password:
								<input id="password" type="password" onKeyUp={(event) => this.loginHandler(event)} style={{marginLeft: '1%'}}/>
								<input type="button" value="Login" id="btnLogin" onClick={() => this.btnLoginUserPass_onclick()} style={{marginLeft: '4px'}}/>
							</div>
						</div>
					</div>

					<h2 style={{margin: "0", paddingTop: "10px", clear: "both"}}>Template Management</h2>
					<div>
						<div id="templateManagement" style={{padding: "5px 0"}}>
							<select id="cbTemplates" name="templateManagementDropdowns" className="cbTemplates" onChange={() => this.changeSelection()} />
							<input id="btnCreate" name="templateManagementDropdowns" className="btnCreate" type="button" value="Create" onClick={() => this.btnCreate_onclick()} />
							<input id="btnUpdate" name="templateManagementDropdowns" className="btnUpdate" type="button" value="Save"  title="Save the template." style={{marginLeft: '2px', marginRight: '2px'}} onClick={() => this.btnUpdate_onclick()} />
							<input id="btnDelete" name="templateManagementDropdowns" className="btnDelete" type="button" value="Delete" onClick={() => this.btnDelete_onclick()} /><br />
						</div>
					</div>

					<h2 style={{margin: "0", paddingTop: "10px", clear: "both"}}>Run Options</h2>
					<div style={{paddingTop: "5px"}}>
						<label style={{float: "left"}}>QueryString:</label>
						<span style={{display: "block", overflow: "hidden", paddingRight: "20px", paddingLeft: "10px"}}>
                        <input id="queryString" type="text" style={{width: "100%"}} />
                    </span>
					</div>
					<div style={{padding: "6px 0"}}>
						<input id="checkBoxRawInput" style={{display: 'inline-block'}} type="checkbox" value="false" onChange={() => TDEClient.checkBoxRawInput_onchange(document.getElementById("checkBoxRawInput"))} />
						<label form="checkBoxRawInput" style={{fontWeight: "normal", display: "inline-block"}}>Use Raw Input</label>
						<input id="inputFile" type="file" single="true" size="120" style={{display: 'inline-block', paddingLeft: "10px"}}/>
						<input id="btnClear" type="button" value="Clear File" style={{marginLeft: '1%', marginRight: '1%', display: 'inline-block'}} onClick={() => TDEClient.btnClear_onclick()}/>
					</div>
					<textarea id="textBoxRawInput" className="S1" hidden={true} wrap="off"></textarea>


					<div className="flexPane">
						<div className="leftPane" style={{padding: "5px"}}>
							<h3 style={{margin: "0"}}>Template</h3>
							<div id="runDiv" style={{padding: "6px 0"}}>
								<input id="btnRun" name="runDivButton" type="button" value="Save & Run" title="Save then run the template." onClick={() => this.btnRun_onclick()}/>
								<input id="btnRunNoSave" name="runDivButton" style={{marginLeft: '3px', marginRight: '3px'}} type="button" value="Run" title="Run the template without saving." onClick={() => this.btnRunOnly_onclick()} />
								<input id="templateBuilder" name="runDivButton" type="button" value="Template Builder" title="Generate a custom template through use of popup window" onClick={() => this.dispPopUp()}/>
							</div>
						</div>
						<div className="rightPane" style={{padding: "5px 15px 5px 5px"}}>
							<div style={{display:"inline-block"}}>
								<h3 style={{float:"left", margin: "0"}}>Results</h3>
								<div style={{float:"left", margin: "10px", paddingTop: "11px"}}>Duration: <span id="time"></span></div>
							</div>

							<div style={{padding: "6px 0"}}>
								<input id="checkBoxDownload" type="checkbox" value="false" /><label form="checkBoxDownload" style={{fontWeight: "normal", display: "inline-block"}}>Download run results</label>
								<input id="btnClearResponse" type="button" style={{marginLeft: '3px', marginRight: '3px'}} value="Clear Response" title="Clear the response window." onClick={() => TDEClient.btnClearResponse_onclick()} />
								<div style={{float:"right"}}>Last Execution Status: <input id="textBoxStatus" type="text" value="" title="Http Status" wrap="off" onChange={ _=>{}} /></div>
							</div>
						</div>
					</div>
					<div id="splitContainer">
						<div id="splitRow">
							<div style={{flex: '0 0 40%', padding: '5px'}}>
								<textarea id="tbView" className="tbView"></textarea>
							</div>
							<div style={{flex: '1 1 60%', boxSizing: 'border-box'}}>
								<Resizable
									size={{width: "auto"}}
									minHeight={'322px'}
									minWidth='auto'
									onResize = {(e, data) => this.resizeHandler(e, data)}
									enable = {{top:false, right:false, bottom:true, left:false, topRight:false, bottomRight:false, bottomLeft:false, topLeft:false }}
								>
									<textarea id="tbResults" name="S1" wrap="off" readOnly={true} style={{overflow: "auto", minHeight: '322px', margin:"7px 0px -9px 5px"}}></textarea>
								</Resizable>
							</div>
						</div>
				</div>
					<p style={{textAlign: 'left'}}>Copyright &#x00A9; Verizon Connect {new Date().getFullYear()}</p>
					</div>
			</div>
		)
	}

}

export default TDEClient;